import { Component, Vue } from 'vue-property-decorator';
import RegisteredTagModule, {
  REGISTERED_TAG_MODULE_NAME
} from '@/store/modules/registered-tag.module';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { mapState } from 'vuex';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';
import { routeName } from '@/constants/route.constants';
import { CheckIfTagExistsResponse } from '@/models/DTO/registered-tag/check-if-tag-exists-response.model';
import { RegisteredTag } from '@/models/DTO/registered-tag/registered-tag.model';
import AuthenticationModule from '@/store/modules/authentication.module';

@Component({
  computed: {
    ...mapState(REGISTERED_TAG_MODULE_NAME, [
      'doesTagExist',
      'currentRegisteredTag',
      'errorResponse'
    ]),
    page(): string | null | undefined {
      return this.$route.name;
    }
  }
})
export default class PublicGetTagMixin extends Vue {
  public doesTagExist: CheckIfTagExistsResponse | null;
  public currentRegisteredTag: RegisteredTag | null;
  public errorResponse: BaseAPIErrorModel | null;
  public page: string | null | undefined;

  /**
   * Used by both public and vet portal.
   * @param code
   * @param isPublic Defaults to true.
   */
  public async getTagByCode(code: string, isPublic = true): Promise<void> {
    const registeredTagModule: RegisteredTagModule = getModule(
      RegisteredTagModule,
      store
    );

    const authModule: AuthenticationModule = getModule(
      AuthenticationModule,
      store
    );

    await registeredTagModule.isTagRegisteredAction(code);

    if (!this.errorResponse && this.doesTagExist) {
      if (this.doesTagExist.registered && this.doesTagExist.completed) {
        await registeredTagModule.getTagByCodeAction(code);

        if (
          !this.errorResponse &&
          this.currentRegisteredTag &&
          this.currentRegisteredTag.customer
        ) {
          if (isPublic) {
            this.$router.replace({
              name: routeName.public.viewAccess,
              params: {
                tagCode: code
              }
            });
          } else {
            this.$router.replace({
              name: routeName.veterinarian.editCustomer,
              params: {
                tagCode: code,
                customerId: this.currentRegisteredTag.customer?.id ?? ''
              }
            });
          }
        }
      } else if (this.doesTagExist.registered && !this.doesTagExist.completed) {
        this.$bvModal.show('modal-tag-incomplete');
      } else {
        // this.$bvModal.show('modal-no-match');
        await authModule.tagMatchAction(false);

        if (isPublic) {
          this.$router.replace({
            name: routeName.public.register,
            params: {
              tagCode: code
            }
          });
        } else {
          this.$router.replace({
            name: routeName.veterinarian.createRegistration,
            params: {
              tagCode: code
            }
          });
        }
      }
    }
  }
}
